import { render, staticRenderFns } from "./BankCreateUpdate.vue?vue&type=template&id=019ca4e0&"
import script from "./BankCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./BankCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports